<ng-template #alertHost></ng-template>
<div class="fd p_20 mobile-mode-margin">
    <!-- <img class="footer_section_watermark" src="../../../assets/images/Mask_footer.png" alt=" "   aria-hidden="true" /> -->
    <div class="row footer_ali">
        <div class="col-12 col-sm-12 col-md-4 footre-logo-container">
            <img src="../../../assets/siteImg/sitelogo.svg" alt="logo" width="150">
            <p><b>{{'PLAY' | translate}} {{'LIVE_CASINO' | translate}}, {{'AVIATOR' | translate}} & {{'SLOTS' | translate}}</b></p>
       <p>{{'DIVW_INTO_THE_THRILL_OF_LIVE_CASINO_GAMES_THE_ICONIC_AVIATOR_AND_ENGAGING_ONLINE_SLOTS_ALL_ON_ONR_SEAMLESS_GAMING_PLATFORM_ENJOY_LIGHTTNING_FAST_GAMEPLAY_SMOTH_PERFORMANCE_AND_AN_EXCEOTIONAL_EXPERIENCE_ACROSS_MOBILE_AND_DESKTOP' | translate}}</p>
       <!-- <a *ngIf="showApkButton" class="apk_download"  href="https://zupwinbd.com/download/mobile/Zupwin.apk" download>
        <span>Install Android App</span>
  <img src="../../../assets/siteImg/andorid_download.png" alt="apk" width="50" height="50">
</a> -->
        </div>


        <div class="col-6 col-sm-6 col-md-2">
            <h3>
                {{'CASINO' | translate}}
            </h3>
            <ul>
              
                  <li>
                    <a routerLink="/livecasino" (click)="scrollTop()">{{'LIVE_CASINO' | translate}}</a>
                  </li>
                  <li>
                    <a routerLink="/aviator" (click)="scrollTop()">{{'AVIATOR' | translate}}</a>
                  </li>
                  <li>
                    <a routerLink="/ballagames" (click)="scrollTop()">{{'BALLA_GAMES'  | translate}}</a>

                  </li>
                  <li>
                    <a routerLink="/slots" (click)="scrollTop()">{{'SLOTS' | translate}}</a>
                  </li>
                  <li>
                    <a routerLink="/roulette" (click)="scrollTop()">{{'ROULETTE'|translate}}</a>
                  </li>
                  <li>
                    <a routerLink="/blackjack" (click)="scrollTop()">{{'BLACKJACK' | translate}}</a>
                  </li>
                  <li>
                    <a routerLink="/baccarat" (click)="scrollTop()">{{'BACCARAT' | translate}}</a>
                  </li>
                     
                  <li>
                    <a routerLink="/lottery" (click)="scrollTop()">{{'LOTTERY' | translate}}</a>
                  </li>
                  <li>
                    <a routerLink="/providers" (click)="scrollTop()">{{'PROVIDERS' | translate}}</a>
                  </li> 
            </ul>
        </div>

        <div class="col-6 col-sm-6 col-md-2">
            <h3>
              {{'SPORTS' | translate}}
            </h3>
            <ul>
                <li>
                    <a routerLink="/sports" (click)="scrollTop()">{{'LIVE_SPORTS' | translate}}</a>
                  </li>                  
            </ul>
             <h3 class="mt-2">
                {{"SUPPORT"| translate}}
            </h3>
            <ul>
                <!-- <li >
                    <button style="padding: 0;" type="button"  (click)="openLiveSupport()">Help Center</button>
                </li> -->
             
                <li>
                    <a  routerLink="/Responsible-Gaming">{{'RESPONSIBLE_PLAY' | translate }}</a>
                </li>
            </ul>
        </div> 
        <div class="col-6 col-sm-6 col-md-2">
            <h3>
                {{'ABOUT_US' | translate}}
            </h3>
            <ul>
                <li>
                    <a routerLink="/terms-and-conditions" (click)="scrollTop()">{{'TERMS_AND_CONDITIONS' | translate}}</a>
                  </li>
                  <li>
                    <a routerLink="/privacypolicy" (click)="scrollTop()">{{'_PRIVACY_POLICY' | translate}}</a>
                  </li>                

            </ul>
        </div>
        <div class="col-6 col-sm-6 col-md-2">
            <h3>
                {{'PAYMENT_INFO' | translate}}
            </h3>
            <ul>
                <li>
                    <a
                      routerLink="/deposit"
                      (click)="!playerLoggedIn && showPopUp('LOGIN')">
                      {{'DEPOSIT' | translate}} & {{'CASHOUT' | translate}}
                    </a>
                  </li>
                  
            </ul>
            <!-- <h3 class="mt-2">
              {{"LANGUAGES"| translate}}
          </h3> -->
          <!-- <ul>
            
            
                <li class="lang_icon" *ngIf="laguageselect == 'BN'" (click)="opendrop()">
                  <img src="../../../assets/siteImg/language_icon/BN.svg" alt="bangladesh" width="30"> Bangladesh <i class='fas fa-angle-down' style="font-size: 20px;margin-left: 5px;"></i>
              </li> 
                <li class="lang_icon" *ngIf="laguageselect == 'EN'" (click)="opendrop()"> 
                  <img src="../../../assets/siteImg/language_icon/EN.svg" alt="bangladesh" width="30"> Bangladesh <i class='fas fa-angle-down' style="font-size: 20px;margin-left: 5px;"></i>
              </li> 
                <li class="lang_icon" (click)="changeLanguage('BN')" *ngIf="openClose">
                  <img src="../../../assets/siteImg/language_icon/BN.svg" alt="bangladesh" width="30"> Bangladesh 
              </li> 
                <li class="lang_icon" (click)="changeLanguage('EN')" *ngIf="openClose">
                  <img src="../../../assets/siteImg/language_icon/EN.svg" alt="bangladesh" width="30"> English  
              </li> 

          </ul> -->
          <ul class="language-dropdown">
            <!-- Selected language -->
            <!-- <li class="lang_icon" style="background: #01000f;" (click)="toggleDropdown()">
              <img
                [src]="'../../../assets/siteImg/language_icon/' + selectedLang + '.svg'"
                width="30"
                alt="language"
              />
              {{ selectedLang === 'BN' ? 'Bangladesh' : 'English' }}
              <i class="fas fa-angle-down"></i>
            </li> -->
          
            <!-- Dropdown options -->
            <!-- <ng-container *ngIf="openClose" >

              <li
              class="lang_icon lang_icon1"
                *ngFor="let lang of languages"
                (click)="changeLanguage(lang.code)"
              
              >
                <img
                  [src]="'../../../assets/siteImg/language_icon/' + lang.code + '.svg'"
                  width="30"
                  alt="language"
                />
                {{ lang.label }}
              </li>
            </ng-container> -->
          </ul>
          
        </div> 
    </div>
 
</div>